import { LoadableLazy } from '@confluence/loadable';

export const GuestOnboardingModalLoadable = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-GuestOnboardingModal" */ '../src/GuestOnboardingModal.tsx'
			)
		).GuestOnboardingModal,
});
